import { render, staticRenderFns } from "./TabMemberClass.vue?vue&type=template&id=7d333580"
import script from "./TabMemberClass.vue?vue&type=script&lang=js"
export * from "./TabMemberClass.vue?vue&type=script&lang=js"
import style0 from "./TabMemberClass.vue?vue&type=style&index=0&id=7d333580&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports